import { getGroupPermissionFactory, PermissionEnum } from '../../../../common';
import { getLocationManagementModuleName } from './location-management.permissions';

export class GeographicalZonesPermissions {
    static GroupName = `${getLocationManagementModuleName()}.GeographicalZones`;

    static getPermissions = getGroupPermissionFactory(GeographicalZonesPermissions.GroupName);

    static Permissions = {
        Create: GeographicalZonesPermissions.getPermissions(PermissionEnum.CREATE),
        Read: GeographicalZonesPermissions.getPermissions(PermissionEnum.READ),
        ReadAll: GeographicalZonesPermissions.getPermissions(PermissionEnum.READ_ALL),
        Update: GeographicalZonesPermissions.getPermissions(PermissionEnum.UPDATE)
    };
}
